
export const GET_LOGGER_DATA_REQUEST = 'GET_LOGGER_DATA_REQUEST';
export const GET_LOGGER_DATA_SUCCESS = 'GET_LOGGER_DATA_SUCCESS';
export const GET_LOGGER_DATA_FAILED = 'GET_LOGGER_DATA_FAILED';

export const GET_USERS_LIST_REQUEST = 'GET_USERS_LIST_REQUEST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAILED = 'GET_USERS_LIST_FAILED';

export const EDIT_CRADICIALS_REQUEST = 'EDIT_CRADICIALS_REQUEST';
export const EDIT_CRADICIALS_SUCCESS = 'EDIT_CRADICIALS_SUCCESS';
export const EDIT_CRADICIALS_FAILED = 'EDIT_CRADICIALS_FAILED';

export const GET_CRADICIALS_REQUEST = 'GET_CRADICIALS_REQUEST';
export const GET_CRADICIALS_SUCCESS = 'GET_CRADICIALS_SUCCESS';
export const GET_CRADICIALS_FAILED = 'GET_CRADICIALS_FAILED';

export const CHANGE_USER_ROLE_REQUEST = 'CHANGE_USER_ROLE_REQUEST';
export const CHANGE_USER_ROLE_SUCCESS = 'CHANGE_USER_ROLE_SUCCESS';
export const CHANGE_USER_ROLE_FAILED = 'CHANGE_USER_ROLE_FAILED';

export const CHANGE_ROLE_ACCESS_SCRREN_REQUEST = 'CHANGE_ROLE_ACCESS_SCRREN_REQUEST';
export const CHANGE_ROLE_ACCESS_SCRREN_SUCCESS = 'CHANGE_ROLE_ACCESS_SCRREN_SUCCESS';
export const CHANGE_ROLE_ACCESS_SCRREN_FAILED = 'CHANGE_ROLE_ACCESS_SCRREN_FAILED';

export const CLEAR_ADMIN_RESPONSE = 'CLEAR_ADMIN_RESPONSE';

export const ADD_NEW_USER_REQUEST = 'ADD_NEW_USER_REQUEST'
export const ADD_NEW_USER_SUCCESS = 'ADD_NEW_USER_SUCCESS'
export const ADD_NEW_USER_FAILED = 'ADD_NEW_USER_FAILED'

export const DELETE_USER_REQUEST = 'DELET_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELET_USER_SUCCESS'
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED'

export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST'
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_FAILED = 'EDIT_USER_FAILED'

export const DUPLICATE_USER_REQUEST = 'DUPLICATE_USER_REQUEST'
export const DUPLICATE_USER_SUCCESS = 'DUPLICATE_USER_SUCCESS'
export const DUPLICATE_USER_FAILED = 'DUPLICATE_USER_FAILED'

export const GET_USER_PERMISSION_DATA_REQUEST = 'GET_USER_PERMISSION_DATA_REQUEST'
export const GET_USER_PERMISSION_DATA_SUCCESS = 'GET_USER_PERMISSION_DATA_SUCCESS'
export const GET_USER_PERMISSION_DATA_FAILED = 'GET_USER_PERMISSION_DATA_FAILED'

export const UPLOAD_DOMAIN_WHITELIST_REQUEST = 'UPLOAD_DOMAIN_WHITELIST_REQUEST'
export const UPLOAD_DOMAIN_WHITELIST_SUCCESS = 'UPLOAD_DOMAIN_WHITELIST_SUCCESS'
export const UPLOAD_DOMAIN_WHITELIST_FAILED = 'UPLOAD_DOMAIN_WHITELIST_FAILED'

export const UPLOAD_APP_WHITELIST_REQUEST = 'UPLOAD_APP_WHITELIST_REQUEST'
export const UPLOAD_APP_WHITELIST_SUCCESS = 'UPLOAD_APP_WHITELIST_SUCCESS'
export const UPLOAD_APP_WHITELIST_FAILED = 'UPLOAD_APP_WHITELIST_FAILED'

export const GET_DOMAINWHITELIST_CSV_DATA_REQUEST = 'GET_DOMAINWHITELIST_CSV_DATA_REQUEST'
export const GET_DOMAINWHITELIST_CSV_DATA_SUCCESS = 'GET_DOMAINWHITELIST_CSV_DATA_SUCCESS'
export const GET_DOMAINWHITELIST_CSV_DATA_FAILED = 'GET_DOMAINWHITELIST_CSV_DATA_FAILED'

export const DELETE_WHITELIST_CJSC_REQUEST = 'DELETE_WHITELIST_CJSC_REQUEST'
export const DELETE_WHITELIST_CJSC_SUCCESS = 'DELETE_WHITELIST_CJSC_SUCCESS'
export const DELETE_WHITELIST_CJSC_FAILED = 'DELETE_WHITELIST_CJSC_FAILED'

export const GET_APPWHITELIST_CSV_DATA_REQUEST = 'GET_APPWHITELIST_CSV_DATA_REQUEST'
export const GET_APPWHITELIST_CSV_DATA_SUCCESS = 'GET_APPWHITELIST_CSV_DATA_SUCCESS'
export const GET_APPWHITELIST_CSV_DATA_FAILED = 'GET_APPWHITELIST_CSV_DATA_FAILED'

export const REMOVE_USER_TOKEN_REQUEST = 'REMOVE_USER_TOKEN_REQUEST';
export const REMOVE_USER_TOKEN_SUCCESS = 'REMOVE_USER_TOKEN_SUCCESS';
export const REMOVE_USER_TOKEN_FAILED = 'REMOVE_USER_TOKEN_FAILED';

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';

export const CLEARALL_NOTIFICATIONS_REQUEST = 'CLEARALL_NOTIFICATIONS_REQUEST';
export const CLEARALL_NOTIFICATIONS_SUCCESS = 'CLEARALL_NOTIFICATIONS_SUCCESS';
export const CLEARALL_NOTIFICATIONS_FAILED = 'CLEARALL_NOTIFICATIONS_FAILED';

export const C_GET_ADVERTISER_REQUEST = "C_GET_ADVERTISER_REQUEST"
export const C_GET_ADVERTISER_SUCCESS = "C_GET_ADVERTISER_SUCCESS"
export const C_GET_ADVERTISER_FAILED = "C_GET_ADVERTISER_FAILED"

export const C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST = "C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST"
export const C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS = "C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS"
export const C_ADMIN_GET_S3FILESANDFOLDERS_FAILED  = "C_ADMIN_GET_S3FILESANDFOLDERS_FAILED"

export const GET_NOAS_COUNTER_REQUEST = 'GET_NOAS_COUNTER_REQUEST'
export const GET_NOAS_COUNTER_SUCCESS = 'GET_NOAS_COUNTER_SUCCESS'
export const GET_NOAS_COUNTER_FAILED = 'GET_NOAS_COUNTER_FAILED'

export const UPDATE_NOTIFICATION_READ_COUNT = 'UPDATE_NOTIFICATION_READ_COUNT';

export const getAdvertiser = ()=>{
    return{type:C_GET_ADVERTISER_REQUEST}
}

export const getS3FilesAndFoldersAction = (folderName:any)=>{
    return {type:C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST,payload:folderName}
}

export const getLoggerDataAction = (data: any) => {
    return {
        type: GET_LOGGER_DATA_REQUEST,
        payload: {
            start: data.startDate.toISOString(),
            end: data.endDate.toISOString()
        }
    };
};

export const getUsersListAction = () => {
    return { type: GET_USERS_LIST_REQUEST, };
};

export const EditReportingCradicialsAction = (data: any) => {
    return { type: EDIT_CRADICIALS_REQUEST, payload: data };
};

export const GetReportingCradicialsAction = () => {
    return { type: GET_CRADICIALS_REQUEST };
};

export const ChangedUserRoleAction = (data: any) => {
    return { type: CHANGE_USER_ROLE_REQUEST, payload: data };
};

export const ChangedRoleAccessScreenAction = (data: any) => {
    return { type: CHANGE_ROLE_ACCESS_SCRREN_REQUEST, payload: data };
};

export const AddNewUserAction = (data: any) => {
    return { type: ADD_NEW_USER_REQUEST, payload: data }
} 

export const DeleteUserAction = (email:any)=>{
    return {type: DELETE_USER_REQUEST,payload:email}
}
export const ClearAdminResponce = () => {
    return { type: CLEAR_ADMIN_RESPONSE };
};

export const EditUserAction = (data: any) => {
    return { type: EDIT_USER_REQUEST, payload: data }
}

export const DuplicateUserAction = (data: any,successCallback:any) => {
    return { type: DUPLICATE_USER_REQUEST, payload: data,successCallback:successCallback }
}

export const getUserPermissionsAction = () => {
    return { type: GET_USER_PERMISSION_DATA_REQUEST, };
};

export const UploadDomainWhitelistCSVAction = (data: any,userid:any) => {
    return { type: UPLOAD_DOMAIN_WHITELIST_REQUEST, payload: data,userid:userid }
}

export const UploadAppWhitelistCSVAction = (data: any,userid:any) => {
    return { type: UPLOAD_APP_WHITELIST_REQUEST, payload: data,userid:userid }
}

export const getDomainWhiteListCSV = (data: any) => {
    return { type: GET_DOMAINWHITELIST_CSV_DATA_REQUEST, payload: data };
};
export const getAppWhiteListCSV = (data: any) => {
    return { type: GET_APPWHITELIST_CSV_DATA_REQUEST, payload: data };
};

export const deleteWhitelistAction = (data: any) => {
    return { type: DELETE_WHITELIST_CJSC_REQUEST, payload: data };
};


export const removeUserTokenAction = (email:any)=>{
    return {type: REMOVE_USER_TOKEN_REQUEST,payload:email}
}

export const getNotificationsAction = () => {
    return { type: GET_NOTIFICATIONS_REQUEST, };
};

export const clearAllNotificationsAction = () => {
    return { type: CLEARALL_NOTIFICATIONS_REQUEST, };
};

export const updateNotificationReadCount=(count:number) =>{
    return {type: UPDATE_NOTIFICATION_READ_COUNT,payload:count} 
}

export const GetNoasCounterAction = (startDate: any, endDate: any, dailyHourly:any)=>{
    return{
        type:GET_NOAS_COUNTER_REQUEST,payload: { startDate,  endDate, dailyHourly }
    }
}